import "@ingka/loading/style.scss";
import Loading, { LoadingBall } from "@ingka/loading";
import { useTranslation } from "react-i18next";

export default function Load({text = null}) {
  const [t] = useTranslation("global")
  return (
    <Loading text={text || t("components.loading")} >
      <LoadingBall />
    </Loading>
  )
}